import React, { useState, useEffect, useRef, useContext } from 'react';
import {FormLayout, LegacyStack, InlineError} from '@shopify/polaris';
import { TextField } from '@thinkwell/react.polaris'
import includes from 'lodash/includes'

export default function ContactForm(props) {
  const names = props.names || {
    first_name: 'first_name',
    last_name: 'last_name',
    email: 'email',
    phone: 'phone'
  }

  return (
    <div>
    <FormLayout>
      { props.vertical ?
        ([
          <TextField
              key="first_name"
              required={includes(props.required, 'first_name')}
              label={props.labels && props.labels.first_name || "First name"}
              name={names.first_name}
          />,
          <TextField
            key="last_name"
            required={includes(props.required, 'last_name')}
            label="Last name"
            name={names.last_name}
          />
        ])
        :
        <FormLayout.Group>
          <TextField
            required={includes(props.required, 'first_name')}
            label="First name"
            name={names.first_name}
          />
          <TextField
            required={includes(props.required, 'last_name')}
            label="Last name"
            name={names.last_name}
          />
        </FormLayout.Group>
      }
      <TextField
        required
        label={props.labels && props.labels.email || "Email"}
        name={names.email}
      />
      { props.withPhone ?
        <TextField
          required={includes(props.required, 'phone')}
          label="Phone"
          name={names.phone}
        /> : null }
      {props.children}
    </FormLayout></div>
  );
}
